module.exports = __webpack_public_path__ + "static/media/kpg-accountants-banner3.a0f5c41d.jpg";